import { render, staticRenderFns } from "./CadRecebimentoEmpresas.vue?vue&type=template&id=7b25f58d&"
import script from "./CadRecebimentoEmpresas.vue?vue&type=script&lang=js&"
export * from "./CadRecebimentoEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports